import { BarChart3 } from 'lucide-react';

// Defensive helper — always returns a number or null, never an object
const normalizeScore = (value) =>
  typeof value === 'object' && value !== null
    ? (typeof value.score === 'number' ? value.score : null)
    : (typeof value === 'number' ? value : null);

const scoreColor = (s) =>
  s >= 80 ? 'bg-emerald-50 text-emerald-700 border-emerald-200' :
  s >= 60 ? 'bg-blue-50 text-[#2563eb] border-blue-200' :
  s >= 40 ? 'bg-amber-50 text-amber-700 border-amber-200' :
            'bg-slate-100 text-slate-500 border-slate-200';

/**
 * ScoreBadge — compact score chip + bar-chart icon for opening report modal.
 * Props: score (number|null), source ("linkedin"|"resume"), onOpenReport (fn), size ("sm"|"md")
 */
export function ScoreBadge({ score, source, onOpenReport, size = 'sm' }) {
  const label = source === 'linkedin' ? 'LI' : 'CV';

  // Safety: use normalizeScore to ensure we never render an object
  const numericScore = normalizeScore(score);

  if (numericScore == null) {
    return (
      <span className="text-slate-300 text-xs">—</span>
    );
  }

  return (
    <div className="flex items-center gap-1" data-testid={`score-badge-${source}`}>
      <span className={`inline-flex items-center px-1.5 py-0.5 rounded text-xs font-bold border ${scoreColor(numericScore)}`}>
        {label}: {numericScore}
      </span>
      {onOpenReport && (
        <button
          onClick={(e) => { e.stopPropagation(); onOpenReport(); }}
          title={`View ${source === 'linkedin' ? 'LinkedIn' : 'Resume'} score report`}
          className="p-0.5 text-slate-300 hover:text-[#2563eb] transition-colors"
          data-testid={`open-report-${source}`}
        >
          <BarChart3 className="w-3 h-3" />
        </button>
      )}
    </div>
  );
}
